import React, { Component } from 'react';

class ContactForm extends Component {

	componentDidMount() {

    const $ = window.$;
    	
       	// Get the form.
	var form = $('#contact-form');

	// Get the messages div.
	var formMessages = $('.form-messege');

	// Set up an event listener for the contact form.
	$(form).submit(function(e) {
		// Stop the browser from submitting the form.
		e.preventDefault();

		// Serialize the form data.
		var formData = $(form).serialize();

		// Submit the form using AJAX.
		$.ajax({
			type: 'POST',
			url: $(form).attr('action'),
			data: formData
		})
		.done(function(response) {
			// Make sure that the formMessages div has the 'success' class.
			$(formMessages).removeClass('error');
			$(formMessages).addClass('success');

			// Set the message text.
			$(formMessages).text(response);

			// Clear the form.
			$('#contact-form input,#contact-form textarea').val('');
		})
		.fail(function(data) {
			// Make sure that the formMessages div has the 'error' class.
			$(formMessages).removeClass('success');
			$(formMessages).addClass('error');

			// Set the message text.
			if (data.responseText !== '') {
				$(formMessages).text(data.responseText);
			} else {
				$(formMessages).text('Oops! An error occured and your message could not be sent.');
			}
		});
	});
    }

    render() {
        let publicUrl = process.env.PUBLIC_URL+'/'

        return <form className="contact-form" action={publicUrl+"mail.php"} method="POST">
            <div className="form-group"><i className="fa fa-user" /><input id="name" name="name" className="form-control input-style-one" type="text" placeholder="Name" required /></div>
            <div className="form-group"><i className="fa fa-at" /><input id="email" name="email" className="form-control input-style-one" type="email" placeholder="Email" required /></div>
            <div className="form-group"><i className="fa fa-pencil" /><textarea id="comments" name="comments" className="form-control input-style-one" placeholder="Your Message" defaultValue={""} /></div>
            <div className="form-group"><input className="btn btn_custom corpo-r-btn btn-style-two" type="submit" defaultValue="SUBMIT MESSAGE" /></div>
            <p className="form-messege mb-0 mt-20" />
        </form>
    }
}

export default ContactForm